
export const roomTeamAssignmentPayload = (session) => {
    const {id, panelId, panelName } = session;
  
   const payload = {
         attributes: {
                      name: panelName,
                      sessionId:id
                  },
          id: panelId,
          type: session.type,
          relationships: {
              judges: { data: [] },
              sessions: {
                  data: [
                      {
                          id: id,
                          type: "session"
                      }
                  ]
              }
          }
    }
  
    return payload;
  
  }
  
  export const tableTeamAssignmentPayload = (session) => {
    const {id, panelId, panelName } = session;
  
    const payload = {
         attributes: {
                      name: panelName,
                      sessionId:id
                  },
          id: panelId,
          type: session.type,
          relationships: {
              referees: { data: [] },
              sessions: {
                  data: [
                      {
                          id: id,
                          type: "session"
                      }
                  ]
              }
          }
    }
  
    return payload;
  
  }
  